<ng-container *ngIf="dialog$ | async as dialog">
    <div class="modal-header p-4">
      <div class="modal-title" [innerHTML]="title"></div>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close(dialog, false)">
        <span aria-hidden="true">×</span>
      </button>
    </div>

  <ng-container *ngIf="step === 0">
    <div class="modal-body mb-4">
      <ng-container *ngFor="let copyOption of copyCampaignOptions; let idx = index;">
        <div class="copy-campaign-item" [class.selected]="copyOption.selected" [class.disabled]="!copyOption.available"  (click)="onSelect(copyOption.id)">
          <div *ngIf="!copyOption.selected" class="copy-type__unselected mr-3"></div>
          <svg *ngIf="copyOption.selected" class="copy-type__selected mr-3" width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <title>Oval</title>
            <g id="New-Compaign" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Campiagn-type-cell" transform="translate(-14.000000, -57.000000)">
                <g>
                  <circle id="Oval" stroke-opacity="0.110549607" stroke="#000026" cx="25" cy="68" r="10"></circle>
                  <g id="Selection">
                    <rect id="Rectangle" stroke="#25C157" stroke-width="2" x="0" y="0" width="386" height="136" rx="7"></rect>
                    <path d="M23.4706625,72.1552419 C23.5178381,72.1314122 23.5620889,72.0998023 23.6014921,72.0603986 L30.6397097,65.0220417 C30.8389448,64.8228028 30.8395982,64.4992555 30.6404473,64.3001008 L30.2787227,63.9383691 C30.0802512,63.7398936 29.7563542,63.7395444 29.5567959,63.9391065 L23.2397766,70.2562506 L20.443227,67.4596458 C20.2427326,67.2591475 19.9202293,67.2595316 19.7210784,67.4586863 L19.3593538,67.820418 C19.1608823,68.0188935 19.1606325,68.3428962 19.3603133,68.542581 L22.8778393,72.0601765 C23.0390772,72.2214176 23.2792232,72.2527401 23.4706625,72.1552419 Z M15,68 C15,62.4771526 19.4759382,58 25,58 C30.5228475,58 35,62.4759382 35,68 C35,73.5228474 30.5240618,78 25,78 C19.4771525,78 15,73.5240618 15,68 Z" id="Shape" fill="#25C157" fill-rule="nonzero"></path>
                  </g>
                </g>
              </g>
            </g>
          </svg>
          <ng-container *ngIf="copyOption.id === 0 &&  copyOption.id !== 3">
            <app-icon-copy-all></app-icon-copy-all>
          </ng-container>
          <ng-container *ngIf="copyOption.id === 1 ||  copyOption.id === 2">
            <app-icon-copy-some></app-icon-copy-some>
          </ng-container>
          <ng-container *ngIf="copyOption.id === 3">
            <app-icon-copy-unsold></app-icon-copy-unsold>
          </ng-container>
          <ng-container *ngIf="copyOption.id === 4">
            <app-icon-copy-unsold></app-icon-copy-unsold>
          </ng-container>
          <div class="name-wrapper">
            <div class="title" [innerText]="copyOption.title"></div>
            <div class="description" [innerText]="copyOption.description"></div>
            <div [class.selected]="copyOption.selected" class="confirm-button justify-content-end">
              <button class="btn btn--paybee btn--success" (click)="onChooseCopyType(copyOption.type)">Confirm</button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="step === 1">
    <ng-container *ngIf="copyType === copyTypes.PARTLY_COPY_TO_EXISTING || copyType === copyTypes.PARTLY_COPY_TO_NEW">
      <div class="modal-body p-0 mb-4">
        <div class="items-title justify-content-between mb-3">
          <button class="btn btn--paybee modal-outline-button btn--sm text-center mr-3" *ngIf="!isAllSelected" (click)="selectAll()">Select All</button>
          <button class="btn btn--paybee modal-outline-button btn--sm text-center mr-3" *ngIf="isAllSelected" (click)="unSelectAll()">Unselect All</button>

          <div class="card__right-side d-flex justify-content-end search">
            <div class="search__icon-wrapper">
              <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>Icons/search</title>
                <defs>
                  <rect id="path-1" x="0" y="0" width="726" height="404" rx="8"></rect>
                  <filter id="filter-3">
                    <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"></feColorMatrix>
                  </filter>
                </defs>
                <g id="New-Compaign" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Large" transform="translate(-858.000000, -165.000000)">
                    <rect fill="#f1f1f1" x="0" y="0" width="1024" height="882"></rect>
                    <g id="Card" transform="translate(274.000000, 150.000000)">
                      <mask id="mask-2" fill="white">
                        <use xlink:href="#path-1"></use>
                      </mask>
                      <g id="Rectangle"></g>
                    </g>
                    <g id="Icons/search" transform="translate(858.000000, 165.000000)">
                      <g filter="url(#filter-3)" id="Color">
                        <g>
                          <path d="M8.05514748,-6.92779167e-14 C3.61630998,-6.92779167e-14 0,3.61627943 0,8.05514748 C0,12.4939989 3.61630443,16.1103033 8.05514748,16.1103033 C9.97490799,16.1103033 11.7382908,15.4316646 13.1243348,14.3048316 L18.5754498,19.755941 C18.9008413,20.0813298 19.4305328,20.0813576 19.7559438,19.755941 C20.0813521,19.4305245 20.0813521,18.9095246 19.7559438,18.5841359 L14.3048316,13.1330265 C15.4339396,11.7462769 16.110295,9.97705522 16.110295,8.05514748 C16.110295,3.61627943 12.4939878,-6.92779167e-14 8.05514748,-6.92779167e-14 Z M8.05514748,1.66658281 C11.5932936,1.66658281 14.4437122,4.51697637 14.4437122,8.05514748 C14.4437122,11.5932769 11.593288,14.4437205 8.05514748,14.4437205 C4.51700692,14.4437205 1.66658281,11.5932769 1.66658281,8.05514748 C1.66658281,4.51697637 4.51700137,1.66658281 8.05514748,1.66658281 Z" id="search" fill="#000000" fill-rule="nonzero"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <input [formControl]="search" class="form-control--search" placeholder="Search" />
            <div class="search__icon-wrapper--cross px-1"><span class="cursor-pointer" *ngIf="search.value.length > 0" (click)="resetSearch()">X</span></div>
          </div>
        </div>
        <ng-container *ngFor="let option of filteredOptions | paginate : { itemsPerPage: 7, currentPage: p }; let idx = index">
          <label class="option-wrapper" for="option-{{ option.id }}">
            <div class="option-item-number">
              <span [innerText]="(7 * (p - 1)) + (idx + 1)"></span>
            </div>
            <div class="option-item-checkbox">
              <input
                id="option-{{ option.id }}"
                mdbCheckbox
                class="form-check-input--paybee"
                type="checkbox"
                [checked]="option.checked"
                (change)="onChange($event, option.id)"
              />
            </div>
            <div class="option-item-image">
              <img [src]="option.imageUrl || '/images/org_logo_default_v2.svg'" alt="thumbnail" class="preset-option__image">
            </div>
            <div class="option-item-name">
              <span [innerHTML]="option.name"></span>
            </div>
          </label>
        </ng-container>
        <div class="items-bottom justify-content-between">
          <div class="options-count">
            Total Items Count: <span>{{ filteredOptions.length }}</span>
          </div>
          <pagination-controls class="mt-4 mr-4 option-pagination" *ngIf="filteredOptions.length >= 7" (pageChange)="p = $event"></pagination-controls>
        </div>
      </div>
      <div class="modal-footer">
        <div class="d-flex w-100 justify-content-between">
          <button type="button" class="btn btn--paybee modal-outline-button btn--md text-center mr-2" (click)="onPrevStep()">← Back</button>
          <button type="button" class="btn btn--paybee btn--black btn--md text-center" [disabled]="!selectedCount"  (click)="onNextStep()">Select {{ selectedCount }} Items</button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="copyType === copyTypes.COPY_UNSOLD_TO_NEW || copyType === copyTypes.COPY_UNSOLD_TO_EXISTING ">
      <div class="modal-body p-0 mb-4">
        @if(unsoldOptions.length > 0){
          <div class="items-title justify-content-between mb-3">
            <button class="btn btn--paybee modal-outline-button btn--sm text-center mr-3" *ngIf="!isAllSelected" (click)="selectAll()">Select All</button>
            <button class="btn btn--paybee modal-outline-button btn--sm text-center mr-3" *ngIf="isAllSelected" (click)="unSelectAll()">Unselect All</button>
  
            <div class="card__right-side d-flex justify-content-end search">
              <div class="search__icon-wrapper">
                <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <title>Icons/search</title>
                  <defs>
                    <rect id="path-1" x="0" y="0" width="726" height="404" rx="8"></rect>
                    <filter id="filter-3">
                      <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"></feColorMatrix>
                    </filter>
                  </defs>
                  <g id="New-Compaign" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Large" transform="translate(-858.000000, -165.000000)">
                      <rect fill="#f1f1f1" x="0" y="0" width="1024" height="882"></rect>
                      <g id="Card" transform="translate(274.000000, 150.000000)">
                        <mask id="mask-2" fill="white">
                          <use xlink:href="#path-1"></use>
                        </mask>
                        <g id="Rectangle"></g>
                      </g>
                      <g id="Icons/search" transform="translate(858.000000, 165.000000)">
                        <g filter="url(#filter-3)" id="Color">
                          <g>
                            <path d="M8.05514748,-6.92779167e-14 C3.61630998,-6.92779167e-14 0,3.61627943 0,8.05514748 C0,12.4939989 3.61630443,16.1103033 8.05514748,16.1103033 C9.97490799,16.1103033 11.7382908,15.4316646 13.1243348,14.3048316 L18.5754498,19.755941 C18.9008413,20.0813298 19.4305328,20.0813576 19.7559438,19.755941 C20.0813521,19.4305245 20.0813521,18.9095246 19.7559438,18.5841359 L14.3048316,13.1330265 C15.4339396,11.7462769 16.110295,9.97705522 16.110295,8.05514748 C16.110295,3.61627943 12.4939878,-6.92779167e-14 8.05514748,-6.92779167e-14 Z M8.05514748,1.66658281 C11.5932936,1.66658281 14.4437122,4.51697637 14.4437122,8.05514748 C14.4437122,11.5932769 11.593288,14.4437205 8.05514748,14.4437205 C4.51700692,14.4437205 1.66658281,11.5932769 1.66658281,8.05514748 C1.66658281,4.51697637 4.51700137,1.66658281 8.05514748,1.66658281 Z" id="search" fill="#000000" fill-rule="nonzero"></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <input [formControl]="search" class="form-control--search" placeholder="Search" />
              <div class="search__icon-wrapper--cross px-1"><span class="cursor-pointer" *ngIf="search.value.length > 0" (click)="resetSearch()">X</span></div>
            </div>
          </div>
          <ng-container *ngFor="let option of unsoldFilteredOptions | paginate : { itemsPerPage: 7, currentPage: p }; let idx = index">
            <label class="option-wrapper" for="option-{{ option.id }}">
              <div class="option-item-number">
                <span [innerText]="(7 * (p - 1)) + (idx + 1)"></span>
              </div>
              <div class="option-item-checkbox">
                <input
                  id="option-{{ option.id }}"
                  mdbCheckbox
                  class="form-check-input--paybee"
                  type="checkbox"
                  [checked]="option.checked"
                  (change)="onChange($event, option.id)"
                />
              </div>
              <div class="option-item-image">
                <img [src]="option.imageUrl || '/images/org_logo_default_v2.svg'" alt="thumbnail" class="preset-option__image">
              </div>
              <div class="option-item-name d-flex flex-column">
                <span [innerHTML]="option.name"></span>
                <span class='body-2' [innerHTML]="getCountText(option)"></span>
              </div>
            </label>
          </ng-container>
          <div class="items-bottom justify-content-between">
            <div class="options-count">
              Total Items Count: <span>{{ unsoldFilteredOptions.length }}</span>
            </div>
            <pagination-controls class="mt-4 mr-4 option-pagination" *ngIf="unsoldFilteredOptions.length >= 7" (pageChange)="p = $event"></pagination-controls>
          </div>
        }@else{
          <span class="text-center d-block body-1" style="height: 50px;">This Auction campaign does not have unsold Items</span>
        }
      </div>
      <div class="modal-footer">
        <div class="d-flex w-100 justify-content-between">
          <button type="button" class="btn btn--paybee modal-outline-button btn--md text-center mr-2" (click)="onPrevStep()">← Back</button>
          @if(unsoldOptions.length > 0){
            <button type="button" class="btn btn--paybee btn--black btn--md text-center" [disabled]="!selectedUnSoldCount"  (click)="onNextStep()">Select {{ selectedUnSoldCount }} Items</button>
          }
        </div>
      </div>
    </ng-container>

    <ng-container [formGroup]="fullCopyForm" *ngIf="copyType === copyTypes.FULL_COPY_TO_NEW">
      <div class="modal-body mb-4 step-2">
        <mdb-form-control class="form-fill w-50">
          <app-mdbp-input mdbInput formControlName="auctionName" label='New Auction Campaign Name'></app-mdbp-input>
          <mdb-error class="form-fill-error" *ngIf="fullCopyForm.controls.auctionName.hasError('required') && fullCopyForm.controls.auctionName.touched">Please Choose Campaign</mdb-error>
        </mdb-form-control>
      </div>

      <div class="modal-footer w-100 justify-content-between">
        <button type="button" class="btn btn--paybee modal-outline-button btn--md text-center mr-2" (click)="onPrevStep()">← Back</button>
        <button type="button" class="btn btn--paybee btn--success btn--md text-center" [class.modal-disabled-button]="fullCopyForm.invalid" [disabled]="fullCopyForm.invalid" (click)="copyCampaign(copyTypes.FULL_COPY_TO_NEW)">Copy Campaign</button>
      </div>
    </ng-container>
  </ng-container>

  <ng-container [formGroup]="partlyCopyToExistingForm" *ngIf="step === 2 && copyType === copyTypes.PARTLY_COPY_TO_EXISTING">
    <div class="modal-body mb-4 step-2">
        <ng-container *ngIf="auctions$ | async as auctions">
          @if(auctions.length > 0){
            <mdb-form-control class="form-fill col-8" data-panel="settings">
              <mdb-select formControlName="campaign" [(ngModel)]="selectedCampaign" class="mdb-select" data-panel="settings">
                <mdb-option *ngFor="let auction of auctions; let idx = index" [value]="auction">{{auction.name}}</mdb-option>
                <label mdbLabel class="form-label form-label--paybee">Select Campaign</label>
              </mdb-select>
              <mdb-error class="form-fill-error" *ngIf="partlyCopyToExistingForm.controls.campaign.hasError('required') && partlyCopyToExistingForm.controls.campaign.touched">Please Choose Campaign</mdb-error>
            </mdb-form-control>
          }@else{
            <span class="body-1 d-block mb-3">No active Auction campaign. Please create one first.</span>
          }
        </ng-container>
    </div>

    <div class="modal-footer">
      <div class="d-flex w-100 justify-content-between">
        <button type="button" class="btn btn--paybee modal-outline-button btn--md text-center mr-2" (click)="onPrevStep()">←Back</button>
        <button type="button" class="btn btn--paybee btn--success btn--md text-center" [class.modal-disabled-button] = "partlyCopyToExistingForm.invalid || !selectedOptions.length" [disabled]="partlyCopyToExistingForm.invalid || !selectedOptions.length"  (click)="copyCampaign(copyTypes.PARTLY_COPY_TO_EXISTING)">Copy {{ selectedCount }} Items</button>
      </div>
    </div>
  </ng-container>

  <ng-container [formGroup]="partlyCopyToNewForm" *ngIf="step === 2 && copyType === copyTypes.PARTLY_COPY_TO_NEW">
    <div class="modal-body mb-4 step-2">
      <mdb-form-control class="form-fill w-50">
        <app-mdbp-input mdbInput formControlName="newAuctionName" label='New Auction Name'></app-mdbp-input>
        <mdb-error class="form-fill-error" *ngIf="partlyCopyToNewForm.controls.newAuctionName.hasError('required') && partlyCopyToNewForm.controls.newAuctionName.touched">Please Choose Campaign</mdb-error>
      </mdb-form-control>
    </div>

    <div class="modal-footer">
      <div class="d-flex w-100 justify-content-between">
        <button type="button" class="btn btn--paybee modal-outline-button btn--md text-center mr-2" (click)="onPrevStep()">← Back</button>
        <button type="button" class="btn btn--paybee btn--success btn--md text-center" [class.modal-disabled-button]="partlyCopyToNewForm.invalid || !selectedOptions.length" [disabled]="partlyCopyToNewForm.invalid || !selectedOptions.length" (click)="copyCampaign(copyTypes.PARTLY_COPY_TO_NEW)">Create New With {{ selectedCount }} Items</button>
      </div>
    </div>
  </ng-container>

  <ng-container [formGroup]="copyUnSoldToNewForm" *ngIf="step === 2 && copyType === copyTypes.COPY_UNSOLD_TO_NEW">
    <div class="modal-body mb-4 step-2">
      <mdb-form-control class="form-fill w-50">
        <app-mdbp-input mdbInput formControlName="newAuctionName" label='New Auction Name'></app-mdbp-input>
        <mdb-error class="form-fill-error" *ngIf="copyUnSoldToNewForm.controls.newAuctionName.hasError('required') && copyUnSoldToNewForm.controls.newAuctionName.touched">Please Choose Campaign</mdb-error>
      </mdb-form-control>
    </div>

    <div class="modal-footer">
      <div class="d-flex w-100 justify-content-between">
        <button type="button" class="btn btn--paybee modal-outline-button btn--md text-center mr-2" (click)="onPrevStep()">← Back</button>
        <button type="button" class="btn btn--paybee btn--success btn--md text-center" [class.modal-disabled-button]="copyUnSoldToNewForm.invalid || !selectedUnSoldOptions.length" [disabled]="copyUnSoldToNewForm.invalid || !selectedUnSoldOptions.length" (click)="copyCampaign(copyTypes.COPY_UNSOLD_TO_NEW)">Create New With {{ selectedUnSoldCount }} Items</button>
      </div>
    </div>
  </ng-container>

  <ng-container [formGroup]="copyUnSoldToExistingForm" *ngIf="step === 2 && copyType === copyTypes.COPY_UNSOLD_TO_EXISTING">
    <div class="modal-body mb-4 step-2">
        <ng-container *ngIf="auctions$ | async as auctions">
          @if(auctions.length > 0){
            <mdb-form-control class="form-fill col-8" data-panel="settings">
              <mdb-select formControlName="campaign" [(ngModel)]="selectedCampaign" class="mdb-select" data-panel="settings">
                <mdb-option *ngFor="let auction of auctions; let idx = index" [value]="auction">{{auction.name}}</mdb-option>
                <label mdbLabel class="form-label form-label--paybee">Select Campaign</label>
              </mdb-select>
              <mdb-error class="form-fill-error" *ngIf="copyUnSoldToExistingForm.controls.campaign.hasError('required') && copyUnSoldToExistingForm.controls.campaign.touched">Please Choose Campaign</mdb-error>
            </mdb-form-control>
          }@else{
            <span class="body-1 d-block mb-3">No active Auction campaign. Please create one first.</span>
          }
        </ng-container>
    </div>

    <div class="modal-footer">
      <div class="d-flex w-100 justify-content-between">
        <button type="button" class="btn btn--paybee modal-outline-button btn--md text-center mr-2" (click)="onPrevStep()">←Back</button>
        <button type="button" class="btn btn--paybee btn--success btn--md text-center" [class.modal-disabled-button] = "copyUnSoldToExistingForm.invalid || !selectedUnSoldOptions.length" [disabled]="copyUnSoldToExistingForm.invalid || !selectedUnSoldOptions.length"  (click)="copyCampaign(copyTypes.COPY_UNSOLD_TO_EXISTING)">Copy {{ selectedUnSoldCount }} Items</button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="step === 3">
    <div class="modal-body mb-4 step-2" style="min-height: 300px;">
      <div class="success-icon">
        <app-icon-success class="mr-0"></app-icon-success>
      </div>
      <div class="final-text">
        @if(copyType === copyTypes.COPY_UNSOLD_TO_NEW || copyType === copyTypes.COPY_UNSOLD_TO_EXISTING){
            {{selectedUnSoldCount}} items from <span>{{ campaign.name }}</span> have been copied to <span> {{ campaignName }}</span>
        }@else{
            {{selectedCount}} items from <span>{{ campaign.name }}</span> have been copied to <span> {{ campaignName }}</span>
        }
      </div>

      <div class="campaign-buttons">
        <button type="button" class="btn btn--paybee btn-sm modal-outline-button text-center custom-btn--paybee" (click)="onEditCampaign()">View Campaign Settings</button>
      </div>
    </div>
  </ng-container>
</ng-container>
